import { connect } from 'react-redux';

import SectionsWrapper from './sections_wrapper.jsx';

import {
  APP_CONTAINER_SELECTOR
} from 'zoomforth_codesbane_viewer/const/dom_selectors.js';

import {
  getIsUsingV1Styles
} from 'zoomforth_codesbane_viewer/reducers/index.js';

const mapStateToProps = (state) => {
  const isUsingV1Styles = getIsUsingV1Styles(state);
  const baseScrollContainer = APP_CONTAINER_SELECTOR;
  
  return {
    baseScrollContainer,
    isUsingV1Styles
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SectionsWrapper);
